import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Typography from '@material-ui/core/Typography';

const style = { marginRight: 'auto', paddingLeft: '8px' };

function label({ state, at }) {
  if (state === 'saving') return 'Salvando...';
  if (state === 'error') return 'Não foi possível salvar o rascunho';

  const savedAt = moment(at);
  return savedAt.isSame(moment(), 'day')
    ? `Rascunho salvo às ${savedAt.format('HH:mm')}`
    : `Rascunho salvo em ${savedAt.format('DD/MM [às] HH:mm')}`;
}

function DraftStatus({ status }) {
  if (!status) return null;

  return (
    <Typography
      variant="caption"
      color={status.state === 'error' ? 'error' : 'textSecondary'}
      style={style}
    >
      {label(status)}
    </Typography>
  );
}

DraftStatus.propTypes = {
  status: PropTypes.object,
};

DraftStatus.defaultProps = {
  status: null,
};

export default DraftStatus;
